import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[wordWrap]'
})
export class WordWrapDirective implements OnInit {

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    setTimeout(() => {
      if (this.el && this.el.nativeElement) {
        const str = this.el.nativeElement.innerText.trim();
        if (str.indexOf(' ') >= 0) {
          this.renderer.setStyle(this.el.nativeElement, 'word-wrap', 'break-word')
        } else {
          this.renderer.setStyle(this.el.nativeElement, 'word-break', 'break-all')
        }
      }
    })
  }

}